import src from "IMAGE";
export default { src, width: 500, height: 75, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ADQ0NKMkJCRsJSUlbykpKXoqKip6LCwsfSoqKnotLS2Jf1IH7IrkRmsAAAAASUVORK5CYII="};
